import React from 'react';
import { MenuCategoryHeader } from "../../Header/MenuCategory";
import { BASE_PATH_PORTAL} from '../../../constants/general';

export function CategoryMenuHeader() {

    return(
        <nav className="categoryMenuHeader">
            <ul>
                <li className="productosNewCat">
                    <a href={`${BASE_PATH_PORTAL}/categoria/`}>Categorías</a>
                    <MenuCategoryHeader />
                </li>
            </ul>
        </nav>
    )
}